import axios from "axios";

export const GOOGLE_MAPS_APIKEY = "AIzaSyC_PRT_UVj042znc1JALwlMzQ2LK0Gbgow";

export const helper = {
  async uploadMediaService(imagee) {
    const form = new FormData();
    form.append("file", imagee);
    form.append("upload_preset", "tuytnefv");
    form.append("cloud_name", "dgooan4ix");

    return new Promise((resolve, reject) => {
      axios
        .post(`https://api.cloudinary.com/v1_1/dgooan4ix/image/upload`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status == 200 || response.status == 201) {
            resolve(response.data.secure_url);
          } else {
            reject("Image uploading failed.");
          }
        })
        .catch((error) => {
          reject("Image uploading failed.");
        });
    });
  },
  async getLatLongFromAddress(address) {
    try {
      const response = await axios.get(
        "https://maps.googleapis.com/maps/api/geocode/json",
        {
          params: {
            address,
            key: "AIzaSyDgm3VBE9YF9fIYqHU6Cue4OfJBtJBlxj4",
          },
        }
      );

      console.log(response.data, address, "asldkajsldjas");
      if (response.data.status === "OK") {
        const location = response.data.results[0].geometry.location;
        return { lat: location.lat, lng: location.lng };
      } else {
        throw new Error(`Geocoding failed: ${response.data.status}`);
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error.message);
      throw error; // Re-throw the error for handling by the caller
    }
  },
};
